import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-1"}]]

const IconNumber15Small = createReactComponent('outline', 'number-15-small', 'Number15Small', __iconNode);

export default IconNumber15Small;